import { Navigate } from 'react-router-dom'
import AccountActionPage from '@/components/auth/AccountAction'
import SubscriptionPendingContainer from '@/checkout/components/post-checkout/SubscriptionPendingContainer'
import PasswordResetPage from '@/routes/password/PasswordResetPage'
import SignInPage from '@/routes/sign-in/SignInPage'
import SignUpPage from '@/routes/sign-up/SignUpPage'
import InvitePage from '@/routes/invite/InvitePage'
import { isPaxtonBrand } from '@/util/enterprise'
import type { RouteFactory } from '@/routing/types'

const isPaxton = isPaxtonBrand()

/**
 * Creates authentication-related routes.
 * Non-Paxton brands are redirected to dashboard (SSO/enterprise flow).
 */
export const createAuthRoutes: RouteFactory = () => [
  {
    path: 'sign-in',
    element: isPaxton ? <SignInPage /> : <Navigate to="/dashboard" />,
  },
  {
    path: 'sign-up',
    element: isPaxton ? <SignUpPage /> : <Navigate to="/dashboard" />,
  },
  {
    path: 'forgot-password',
    element: isPaxton ? <PasswordResetPage /> : <Navigate to="/dashboard" />,
  },
  {
    path: 'invite/:inviteId?',
    element: <InvitePage />,
  },
  {
    path: 'account-action',
    element: <AccountActionPage />,
  },
  {
    path: 'pending-subscription',
    element: <SubscriptionPendingContainer />,
  },
]
